import React from "react";
import { Route } from "react-router-dom";
import { StartPage } from "./pages/start-page/start-page";
import { YourBirthdatePage } from "./pages/your-birthdate/your-birthdate";
import { YourBirthPlacePage } from "./pages/your-birthplace/your-birthplace";
import { YourBirthTimePage } from "./pages/your-birthtime/your-birthtime";
import { ResultPage } from "./pages/result/result";
import { PrepareHoroscopePage } from "./pages/prepare-horoscope/prepare-horoscope";
import { MagicalInsightPage } from "./pages/magical-insight/magical-insight";
import { IntuitionPage } from "./pages/intuition/intuition";
import { EnergyPage } from "./pages/energy/energy";
import { CrowdComfortPage } from "./pages/crowd-comfort/crowd-comfort";
import { StormPage } from "./pages/storm/storm";
import { NaturePage } from "./pages/nature/nature";
import { AnimalsPage } from "./pages/animals/animals";
import { ElementsPage } from "./pages/elements/elements";
import { TraditionPage } from "./pages/tradition/tradition";
import { AncestorPage } from "./pages/ancestor/ancestor";
import { LineagePage } from "./pages/lineage/lineage";
import { IntuitiveHealingPage } from "./pages/intuitive-healing/intuitive-healing";
import { SymbolsPage } from "./pages/symbols/symbols";
import { FeelInCrowdPage } from "./pages/skip-pages/feel-in-crowd/feel-in-crowd";
import { MoonPage } from "./pages/skip-pages/moon/moon";
import { WitchSkillPage } from "./pages/skip-pages/witch-skill/witch-skill";

const routes = [
  <Route key={0} index element={<StartPage />} />,
  <Route key={1} path="magical-insight" element={<MagicalInsightPage />} />,
  <Route key={2} path="intuition" element={<IntuitionPage />} />,
  <Route key={3} path="energy" element={<EnergyPage />} />,
  <Route key={4} path="crowd-comfort" element={<CrowdComfortPage />} />,
  <Route key={5} path="storm" element={<StormPage />} />,
  <Route key={6} path="nature" element={<NaturePage />} />,
  <Route key={7} path="animals" element={<AnimalsPage />} />,
  <Route key={8} path="elements" element={<ElementsPage />} />,
  <Route key={9} path="tradition" element={<TraditionPage />} />,
  <Route key={10} path="ancestor" element={<AncestorPage />} />,
  <Route key={11} path="lineage" element={<LineagePage />} />,
  <Route key={12} path="intuitive-healing" element={<IntuitiveHealingPage />} />,
  <Route key={13} path="symbols" element={<SymbolsPage />} />,
  <Route key={14} path="your-birthdate" element={<YourBirthdatePage />} />,
  <Route key={15} path="your-birthplace" element={<YourBirthPlacePage />} />,
  <Route key={16} path="your-birthtime" element={<YourBirthTimePage />} />,
  <Route key={17} path="result" element={<ResultPage />} />,
  <Route key={18} path="horoscope-preparing" element={<PrepareHoroscopePage />} />,
  <Route key={19} path="feel-in-crowd" element={<FeelInCrowdPage />} />,
  <Route key={20} path="witch-skill" element={<WitchSkillPage />} />,
  <Route key={21} path="moon" element={<MoonPage />} />,
];

export { routes };
